<template>
  <div class="d-flex justify-center">
    <EpisodesListing />
  </div>
</template>

<script
  setup
  lang="ts"
>
import EpisodesListing from '../components/Control/EpisodesListing.vue'
</script>